/**
 * used for the RelativeDateRange filter
 */
const dateRangeLabels = [
	{
		id: "PreviousWeek",
		title: "Previous Week",
		dynamicValue: true,
		showWeekStart: true
	},
	{
		id: "CurrentWeek",
		title: "Current Week",
		dynamicValue: true,
		showWeekStart: true
	},
	{
		id: "NextWeek",
		title: "Next Week",
		dynamicValue: true,
		showWeekStart: true
	},
	{
		id: "CurrentMonth",
		title: "Current Month",
		dynamicValue: true,
		showWeekStart: false
	},
	{
		id: "CurrentQuarter",
		title: "Current Quarter",
		dynamicValue: true,
		showWeekStart: false
	}
]

const dateRangeRangeLabels = [
	{
		id: "PreviousWeek",
		title: "Previous Week"
	},
	{
		id: "NextWeek",
		title: "Next Week"
	},
	{
		id: "CurrentWeek",
		title: "Current Week"
	},
	{
		id: "CurrentMonth",
		title: "Current Month"
	},
	{
		id: "CurrentQuarter",
		title: "Current Quarter"
	},
	{
		id: "WeekNumber",
		title: "Week Number"
	},
	{
		id: "MonthRange",
		title: "Month Range"
	},
	{
		id: "YearToDate",
		title: "Year to Date"
	},
	{
		id: "DateRange",
		title: "Date Range"
	}
]

export enum DateRangeOptions {
	PreviousWeek = "PreviousWeek",
	NextWeek = "NextWeek",
	CurrentWeek = "CurrentWeek",
	CurrentMonth = "CurrentMonth",
	CurrentQuarter = "CurrentQuarter",
	WeekNumber = "WeekNumber",
	MonthRange = "MonthRange",
	YearToDate = "YearToDate",
	DateRange = "DateRange"
}

export interface DateRange {
	start: Date,
	end: Date
}

export { dateRangeLabels, dateRangeRangeLabels }
